import React from 'react'
import PropTypes from 'prop-types'
import './style.css'
import Video from "../../../../_common/_icons/Video"
import Chat from "../../../../_common/_icons/Chat"
import PDF from "../../../../_common/_icons/PDF"
import Image from "../../../../_common/_icons/Image"
import Question from "../../../../_common/_icons/Question"
import NRTListItem from "../../../../_common/ListItem"
import UploadIcon from "../../../../_common/_icons/Upload"
import ContentIcon from "../../../../_common/_icons/ContentIcon"
import Lock from "../../../../_common/_icons/Lock";

const iconProps = {width: 22, height: 22}

export const icons = {
    1: <Video  {...iconProps}/>,
    2: <Image {...iconProps} />,
    3: <ContentIcon {...iconProps} />,
    4: <PDF  {...iconProps} />,
    5: <Question  {...iconProps}/>,
    6: <UploadIcon {...iconProps} height={23}/>,
    7: <Chat {...iconProps} />,
}


const CourseTrailContent = (props) => {

    const {
        content,
        active,
        inProgress,
        concluded,
        cls,
        module,
        blocked = false,
    } = props

    const activeCls = (!blocked && active) ? 'active' : ' '
    const completeCls = (!blocked && concluded) ? ' complete ' : ' '
    const inProgressCls = (!blocked && inProgress) ? ' in-progress' : ''

    if (!content) return null
    return (
        <NRTListItem key={"cnt_" + content.code}
                     className={'nrt-course-trail-content ' + activeCls + completeCls + inProgressCls}
                     showOnlySeparator
                     style={{
                         padding: '.7rem',
                         opacity : blocked ? .5 : 1 ,
                     }}
                     onClick={() => {
                         if (blocked) return
                         props.onClick(module, cls, content)
                     }}>

            <div className="content-type-icon-container">
                {blocked ? <Lock/> : icons[content.type] || null }
            </div>

            <p>{content.name}</p>


            {/*{*/}
            {/*content.duration &&*/}
            {/*<p className={'duration'}>{content.duration}</p>*/}
            {/*}*/}
        </NRTListItem>

    )
}


CourseTrailContent.propTypes = {

    blocked: PropTypes.bool,
    active: PropTypes.bool,
    onClick: PropTypes.func,
    content: PropTypes.shape({
        code: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
        type: PropTypes.number.isRequired,
    })


}

CourseTrailContent.defaultProps = {
    complete: false,
    onClick: () => null,
}

export default CourseTrailContent



// WEBPACK FOOTER //
// ./src/components/_ead/CourseTrail/CourseTrailModule/CourseTrailContent/index.js